import React from "react";

import { Action, QuestionState } from "./context/reducer";

const QuestionContext = React.createContext<
  [QuestionState, React.Dispatch<Action>]
>([
  {
    response: {},
  },
  () => {
    //
  },
]);

export default QuestionContext;
